import enhancer from './FormUserTemporaryLocked.enhancer';
import FormUserTemporaryLocked from './FormUserTemporaryLocked';

export default enhancer(FormUserTemporaryLocked);
